import Reveal from "@/components/Reveal";

export default function SectionHeading({ eyebrow, title, copy, testId }) {
  return (
    <Reveal>
      <p className="eyebrow mb-4">{eyebrow}</p>
      <h2 data-testid={testId} className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F6F4EE] leading-tight">
        {title}
      </h2>
      {copy && <p className="mt-5 max-w-2xl text-sm sm:text-base leading-relaxed text-[#A19E95]">{copy}</p>}
      <div className="mt-6 h-px w-20 bg-gradient-to-r from-[#D4AF37] to-transparent" aria-hidden="true" />
    </Reveal>
  );
}
